module.exports = __webpack_public_path__ + "static/media/invoicing-mobile.b6740ac2.webp";